import type { DocPage } from "../types";

export const page: DocPage = {
  slug: "mcp",
  title: "MCP connections",
  navLabel: "MCP connections",
  description:
    "Use Mavori from an external AI client, or connect outside MCP tools to Mavori's hosted Agent.",
  section: "automation",
  published: "2026-08-03",
  updated: "2026-08-03",
  related: ["agent", "skills-and-files", "account"],
  blocks: [
    {
      type: "lead",
      text: "The MCP page manages two opposite connection directions: the **Mavori MCP** tab lets another AI client use Mavori, while **External MCPs** gives Mavori's hosted Agent access to tools from servers you connect.",
    },

    { type: "h2", text: "Choose the connection direction" },
    {
      type: "table",
      caption: "The two connection types available on the MCP page",
      headers: ["Goal", "Open", "What happens"],
      rows: [
        [
          "Use Mavori from Claude, ChatGPT, Codex, Cursor, or another AI client",
          "Mavori MCP",
          "Your outside client signs in to Mavori and can use the Mavori capabilities available to your account.",
        ],
        [
          "Give Mavori's hosted Agent tools from another service",
          "External MCPs",
          "You connect that service to Mavori, then choose which of its tools the hosted Agent may use.",
        ],
      ],
    },

    { type: "h2", text: "Use Mavori from an external AI client" },
    {
      type: "p",
      text: "Open **MCP**, stay on **Mavori MCP**, and choose the client you use. Follow the setup card to add Mavori, then complete the browser sign-in and approve the connection. Start a new session in that client and ask it to use Mavori for research, market data, portfolio context, or other available work. Authorized clients appear under **External agents**, where you can review the connection and revoke it at any time.",
    },

    { type: "h2", text: "Connect an external MCP to the hosted Agent" },
    {
      type: "p",
      text: "Open **External MCPs** and select **Add MCP server**. Give the connection a recognizable name, enter the server address, and choose the sign-in method supplied by its provider. Complete authorization when prompted. After the server is connected, expand it and enable only the **Tools** you want available. When a conversation needs that service, turn the connection on from the Agent composer so the hosted Agent can use those enabled tools alongside Mavori's own capabilities.",
    },

    { type: "h2", text: "Review and remove access" },
    {
      type: "p",
      text: "The two tabs keep ownership clear. Revoke an outside AI client from **External agents** when it should no longer use Mavori. Pause or remove an external MCP server when the hosted Agent should stop using it, and review its enabled tools whenever the provider changes what it offers. Connection availability can depend on your plan; current access and billing are shown under [Account and settings](/docs/account).",
    },
  ],
};
